module.exports = __webpack_public_path__ + "img/Price.b1cd08fb.svg";